var _desc, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g2, _circle128, _circle129, _circle130, _circle131, _circle132, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUcdavis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "tiny",
    viewBox: "-110 -110 220 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n The seal of the University of California, Davis\n") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n This is the seal of the University of California Davis (UC Davis) ;\n it contains the following text:\n THE UNIVERSITY OF CALIFORNIA\n DAVIS\n LET THERE BE LIGHT ;\n see\n http://commons.wikimedia.org/wiki/File:The_University_of_California_Davis.svg\n for more information.\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 100,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(0.00)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(2.86)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(5.71)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(8.57)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(11.43)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(14.29)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(17.14)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(20.00)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(22.86)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(25.71)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(28.57)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(31.43)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(34.29)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(37.14)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(40.00)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(42.86)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(45.71)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(48.57)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(51.43)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(54.29)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(57.14)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(60.00)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(62.86)"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(65.71)"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(68.57)"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(71.43)"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(74.29)"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(77.14)"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(80.00)"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(82.86)"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(85.71)"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(88.57)"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(91.43)"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(94.29)"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(97.14)"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(100.00)"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(102.86)"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(105.71)"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(108.57)"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(111.43)"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(114.29)"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(117.14)"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(120.00)"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(122.86)"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(125.71)"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(128.57)"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(131.43)"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(134.29)"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(137.14)"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(140.00)"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(142.86)"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(145.71)"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(148.57)"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(151.43)"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(154.29)"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(157.14)"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(160.00)"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(162.86)"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(165.71)"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(168.57)"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(171.43)"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(174.29)"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(177.14)"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(180.00)"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(182.86)"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(185.71)"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(188.57)"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(191.43)"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(194.29)"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(197.14)"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(200.00)"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(202.86)"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(205.71)"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(208.57)"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(211.43)"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(214.29)"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(217.14)"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(220.00)"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(222.86)"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(225.71)"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(228.57)"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(231.43)"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(234.29)"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(237.14)"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(240.00)"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(242.86)"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(245.71)"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(248.57)"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(251.43)"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(254.29)"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(257.14)"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(260.00)"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(262.86)"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(265.71)"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(268.57)"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(271.43)"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(274.29)"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(277.14)"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(280.00)"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(282.86)"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(285.71)"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(288.57)"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(291.43)"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(294.29)"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(297.14)"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(300.00)"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(302.86)"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(305.71)"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(308.57)"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(311.43)"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(314.29)"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(317.14)"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(320.00)"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(322.86)"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(325.71)"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(328.57)"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(331.43)"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(334.29)"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(337.14)"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(340.00)"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(342.86)"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(345.71)"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(348.57)"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(351.43)"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(354.29)"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 100,
    fill: "#DAAA00",
    transform: "rotate(357.14)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-15 -63 L-32 -62.5",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-13 -61 L-50 -50",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-11 -59 L-64 -23",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-10 -56 L-70 -1.5",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-10 -51.5 L-67 13",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-8 -49 L-62.5 30",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-7 -45 L-46 55",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.5 -49 L-35 62",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 -50.5 L-23 60",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-9 55 L-11 70.5",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 -61 L32 -59.5",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12 -59 L54 -42",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12 -56 L66 -23",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12 -53 L69 -6",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10 -50 L68 14",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14 -40 L65 27",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24 -20 L58 39",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6 -50 L47 53",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 -50.5 L31.5 58.5",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 55 L16 67.5",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2 55 L2.5 71",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "  M -52 28  c -3 3 -5.5 4 -5.5 9  s 5.5 5 6.5 5  s 5 -1 5 4.5  s 8 7 8 12.5  c 0.5 3 1 -5 -1 -7  c 1 -1 0.5 -1 1.5 -3  c 1 1 8 7 9 7  c 3 0 1.5 -6.5 -2 -3  C -32 51.5 -32 48.5 -34 48.5  c -2 0 -2 -2 -2 -4  s 0 -8.5 -14 -8.5  c -3 0 -3 0 -3 -2  s 1 -4 1 -5  z  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "  M -47.5 -45.5  h 41.5  c 3 0 5 4 6 5  c 1 -1 3 -5 6 -5  h 41.5  v 89  h -43.5  c 0 2 -8 2 -8 0  h -43.5  z  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "  M -35.5 -45.5  v 82  h 29.5  c 3 0 5 4 6 5  c 1 -1 3 -5 6 -5  h 29.5  v -82  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "none"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "  M -38.5 -45.5  v 83.75  h 32.5  c 3 0 5 4 6 5  c 1 -1 3 -5 6 -5  h 32.5  v -83.75  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "none"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "  M -41.5 -45.5  v 85.5  h 35.5  c 3 0 5 2.5 6 3.5  c 1 -1 3 -3.5 6 -3.5  h 35.5  v -85.5  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "none"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "  M -44.5 -45.5  v 87.25  h 38.5  c 3 0 5 0.75 6 1.75  c 1 -1 3 -1.75 6 -1.75  h 38.5  v -87.25  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "none"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "  M 0 -40.5  v 82  ",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "  M -4 43.5  c 0 -6 8 -6 8 0  c 0 2 -8 2 -8 0  z  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "  M6 -41.35 h3 m3 0 h2 m1 0 h3 m3 0 h7 m1 0 h4 m-27 3.2 h1 m1  0 h13 m3 0 h9 m-27 3.2 h4 m1 0 h3 m3 0 h7 m1 0 h4 m1 0 h3  m-27 3.2 h27 m-27 3.2 h1 m1 0 h9 m1 0 h5 m1 0 h9 m-27 3.2  h5 m1 0 h7 m1 0 h7 m3 0 h3 m-27 3.2 h1 m3 0 h5 m1 0 h3 m3 0  h7 m1 0 h3 m-27 3.2 h4 m3 0 h6 m1 0 h4 m3 0 h6 m-27 3.2 h1  m1 0 h9 m1 0 h5 m1 0 h9 m-27 3.2 h2 m1 0 h3 m3 0 h1 m1 0 h3  m3 0 h1 m1 0 h3 m3 0 h2 m-27 3.2 h2 m1 0 h5 m1 0 h3 m3 0 h6  m1 0 h5 m-27 3.2 h10 m1 0 h16 m-27 3.2 h2 m1 0 h12 m3 0 h9  m-27 3.2 h4 m1 0 h5 m3 0 h7 m1 0 h6 m-27 3.2 h27 m-27 3.2  h9 m3 0 h15 m-27 3.2 h3 m1 0 h2 m1 0 h6 m1 0 h4 m1 0 h8  m-27 3.2 h10 m1 0 h16 m-27 3.2 h27 m-27 3.2 h9 m3 0 h15  m-27 3.2 h1.5 m1 0 h19.2 m3 0 h0.6 m1 0 h0.7 m-27 3.2 h0.5  m1 0 h25.5 m-27 3.2 h1.2 m1 0 h24.8 m-27 3.2 h27 m-27 3.2  m -39 -76.8 h3 m3 0 h4 m1 0 h5 m1 0 h5 m1 0 h4 m-27 3.2 h18  m1 0 h8 m-27 3.2 h15 m1 0 h5 m3 0 h3 m-27 3.2 h18 m3 0 h6  m-27 3.2 h27 m-27.1 3.2 h3 m3 0 h4 m1 0 h4 m3 0 h7 m1 0 h1  m-27 3.2 h5 m1 0 h15 m3 0 h3 m-27 3.2 h4 m1 0 h3 m3 0 h7 m1  0 h5 m1 0 h2 m-27 3.2 h2 m1 0 h3 m3 0 h1.5 m1 0 h3 m3 0 h1  m1 0 h4 m3 0 h0.5 m-27 3.2 h27 m-27 3.2 h6 m3 0 h8 m3 0 h5  m1 0 h1 m-27 3.2 h2 m3 0 h7 m3 0 h6 m3 0 h3 m-27 3.2 h27  m-27 3.2 h5 m1 0 h9 m1 0 h8 m1 0 h2 m-27 3.2 h11 m3 0 h13  m-27 3.2 h10 m1 0 h8 m3 0 h5 m-27 3.2 h5 m3 0 h17 m1 0 h1  m-27 3.2 h2 m1 0 h5 m1 0 h3 m3 0 h8 m1 0 h3 m-27 3.2 h3 m3  0 h8 m3 0 h5 m3 0 h2 m-27 3.2 h7 m1 0 h5 m3 0 h7 m1 0 h3  m-27 3.2 h9 m3 0 h5 m1 0 h7 m1 0 h1 m-27 3.2 h9.5 m1 0 h1  m3 0 h1 m1 0 h1 m3 0 h1 m1 0 h1 m3 0 h0.5 m-27 3.2 h27 m-27  3.2 h27 m-27 3.2 m 26.5 -76.8 h0.5 c3 0 5 4 6 5 1 -1 3 -5 6  -5 h0.5 m-13 3.2 h0.5 c3 0 5 4 6 5 1 -1 3 -5 6 -5 h0.5 m-13  3.2 h0.5 c3 0 5 4 6 5 1 -1 3 -5 6 -5 h0.5 m-13 3.2 h0.5 c3  0 5 4 6 5 1 -1 3 -5 6 -5 h0.5 m-13 3.2 h0.5 c3 0 5 4 6 5 1  -1 3 -5 6 -5 h0.5 m-13 3.2 h0.5 c3 0 5 4 6 5 1 -1 3 -5 6 -5  h0.5 m-13 3.2 h0.5 c3 0 5 4 6 5 1 -1 3 -5 6 -5 h0.5 m-13  3.2 h0.5 c3 0 5 4 6 5 1 -1 3 -5 6 -5 h0.5 m-13 3.2 h0.5 c3  0 5 4 6 5 1 -1 3 -5 6 -5 h0.5 m-13 3.2 h0.5 c3 0 5 4 6 5 1  -1 3 -5 6 -5 h0.5 m-13 3.2 h0.5 c3 0 5 4 6 5 1 -1 3 -5 6 -5  h0.5 m-13 3.2 h0.5 c3 0 5 4 6 5 1 -1 3 -5 6 -5 h0.5 m-13  3.2 h0.5 c3 0 5 4 6 5 1 -1 3 -5 6 -5 h0.5 m-13 3.2 h0.5 c3  0 5 4 6 5 1 -1 3 -5 6 -5 h0.5 m-13 3.2 h0.5 c3 0 5 4 6 5 1  -1 3 -5 6 -5 h0.5 m-13 3.2 h0.5 c3 0 5 4 6 5 1 -1 3 -5 6 -5  h0.5 m-13 3.2 h0.5 c3 0 5 4 6 5 1 -1 3 -5 6 -5 h0.5 m-13  3.2 h0.5 c3 0 5 4 6 5 1 -1 3 -5 6 -5 h0.5 m-13 3.2 h0.5 c3  0 5 4 6 5 1 -1 3 -5 6 -5 h0.5 m-13 3.2 h0.5 c3 0 5 4 6 5 1  -1 3 -5 6 -5 h0.5 m-13 3.2 h0.5 c3 0 5 4 6 5 1 -1 3 -5 6 -5  h0.5 m-13 3.2 h0.5 c3 0 5 4 6 5 1 -1 3 -5 6 -5 h0.5 m-13  3.2 h0.5 c3 0 5 4 6 5 1 -1 3 -5 6 -5 h0.5 m-13 3.2 h0.5 c3  0 5 4 6 5 1 -1 3 -5 6 -5 h0.5 m-13 3.2  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "  M -32.5 -38.15  v 9.6  h 9.6  v -9.6  z  ",
    stroke: "white",
    strokeWidth: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "  M -32.5 -38.15  v 9.6  h 9.6  v -9.6  z  m 1.5 8.5  l 3.3 -6.6  l 3.3 6.6  m -4.95 -3.3  h 3.3  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "none"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "  M 21 45  c -7 -5 -6 -12 1 -13  l -7 -2  c -15 6 -9 14.5 4 15  z  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "  M -37 19  c 5 0 7 3 10 6  s 3.5 2.5 7 5  s 4.5 6 9 12  s 13 7 15 7  s 8 0.5 10 -1  s 2 -4.5 5.5 -4.5  s 4.5 5 4.5 7  s -2 14 -22 13.5  s -25 -13 -28.5 -18  s -2 -16 -27 -16  c 0 -2 0.5 -3 0.5 -5  s 0 -4 7 -5  S -42 19 -37 19  z  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "  M 9.5 28  c 0 2 1 3 1 4  s 3 0.5 4 1.5  s 20 6 30 6  s 13 -4 17.5 -14  C 63.1 23 62 20 59 16.5  s -5.5 -5.5 -8 -5.5  s -9 2 -10 2.5  s -10 3 -11 -3.5  s 7.5 -7 10 -5  s 5.5 3 8.5 3  s 6 -2.5 8 -4.5  s 6.5 -3 6.5 -6.5  s -2 -4 -2 -7  c -1 -2 1 5.5 -3 6.5  s -3.5 2 -3.5 2  c -0.5 -3 2 -7.5 -4.5 -9.5  c 4 -5 -5 -5 -3 0  l 2.5 3  c 0.5 1 1 1 1.5 4.5  c -1.5 1 -1.5 1.5 -2.5 3.5  s -7 -0.5 -10 1  s -3 -3 0.5 -3.5  s 2.5 0 3.5 -1.5  s -3 0 -4 -1  s -3 0.5 -4 1  s -7.5 5 -7 12  s 1.5 13.5 10 13  S 49 12 54 17  c 1.5 1.5 0 9.5 -4 9.5  c -25 0 -20 -5 -35 -5  c -6 0 -5.5 3 -5.5 5  z  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "  M 59 16.5  L 54 17  ",
    stroke: "#DAAA00",
    strokeWidth: 1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "  M -35.14 68.46 c 4.31 -13.21 4.89 -11.29 7.83 -7.65 1.52  1.89 4.51 -0.38 4.42 1.67 -0.14 3.20 -2.86 4.64 -3.64 13.55  -4.87 2.56 -8.01 0.52 -8.62 -7.57 z  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "#002855"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "  M 33.82 77.47 c -22.43 5.28 -10.21 -0.22 -10.89 -4.35  -2.43 -14.83 -0.88 -10.35 4.48 -12.64 2.80 -1.19 5.88  -2.37 6.56 -0.48 5.58 21.88 5.97 16.15 -0.16 17.47 z  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "#002855"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "  M -34.24 81.01 c -25.29 -5.73 4.13 -11.49 3.34 -14.84 -2.60  -11.03 1.35 -8.99 3.59 -6.41 1.59 1.84 4.51 0.68 4.42 2.73  -0.14 3.20 -5.24 0.63 -4.70 4.35 1.08 12.63 6.27 18.25  -6.65 14.17 z  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "#002855"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "  M 35.06 80.48 c -22.43 5.28 -4.47 -9.65 -10.10 -13.96 -6.35  -4.86 -2.29 -5.19 2.70 -6.41 2.95 -0.72 5.63 -2.00 6.31  -0.11 0.92 2.55 -2.05 1.49 -3.48 5.32 -1.02 2.72 29.49 7.13  4.56 15.16 z  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "#002855"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "  M -33.14 81.84 c 0.03 -3.32 5.67 -9.86 5.20 -10.75 -2.94  -5.62 1.75 -3.55 7.17 -2.67 3.46 0.56 15.30 3.95 20.84 3.53  1.40 -0.11 5.09 0.62 9.69 -1.69 8.33 -4.16 8.98 -0.32 13.60  -2.78 5.21 -2.78 5.02 0.51 5.15 3.10 0.17 3.66 -0.56 0.16  0.61 4.67 0.63 2.42 4.50 3.19 3.88 7.37 -0.64 4.39 -4.15  5.10 -14.89 7.29 -9.62 1.96 -6.09 2.70 -17.38 2.76 -8.81  0.05 -6.00 -2.53 -23.36 -2.74 -7.05 -0.08 -10.56 -2.80  -10.50 -8.08 z  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "#002855"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "  M 70.44 -55.07 c 1.57 4.27 4.57 4.97 7.17 8.62 2.61 3.65  5.64 12.14 6.85 15.99 2.58 8.22 5.97 12.80 5.96 20.64 -0.02  9.25 0.47 20.47 -0.66 23.78 -1.13 3.31 -4.17 11.47 -5.63  20.85 -1.36 8.73 -8.95 15.95 -10.02 17.18 -1.07 1.23 -4.20  9.73 -12.41 16.15 -3.62 2.83 -8.80 6.32 -13.23 9.54 -3.99  2.90 -5.88 5.68 -8.22 5.35 -2.34 -0.33 -3.94 -3.18 -4.40  -6.78 -0.29 -2.25 -0.73 -3.91 -3.82 -7.58 -2.67 -3.17 -3.39  -4.15 2.39 -4.82 4.14 -0.48 9.90 -8.72 13.28 -9.78 3.38  -1.06 10.22 -11.40 16.58 -25.10 4.62 -9.98 7.28 -23.95 4.66  -42.19 -2.47 -17.20 -5.83 -18.57 -11.29 -26.84 -4.41 -6.68  -7.52 -11.62 -13.50 -14.80 -0.94 -0.50 -3.62 -1.14 -6.98  -4.27 -1.94 -1.81 -4.82 -2.95 -7.35 -4.41 -2.53 -1.46  -19.85 -7.84 -29.32 -8.11 -7.81 -0.22 -19.21 1.43 -37.15  11.16 -6.11 3.32 -11.99 8.28 -19.60 16.88 -3.14 3.55 -4.09  7.93 -5.88 11.74 -0.99 2.12 -2.86 3.82 -4.05 5.69 -4.52  7.12 -5.43 20.02 -5.44 25.85 -0.03 9.80 3.61 16.83 3.71  21.52 0.16 7.17 4.23 12.06 9.27 20.65 2.99 5.10 9.20 10.91  12.73 13.27 3.73 2.48 5.55 5.63 10.61 8.05 8.41 4.02 1.87  5.24 0.49 9.46 -0.76 2.33 -1.57 13.24 -8.02 9.13 -3.14  -2.00 -8.42 -4.63 -13.35 -8.69 -1.49 -1.23 -9.60 -6.39  -12.87 -13.36 -0.99 -2.11 -5.77 -7.14 -9.95 -13.68 -3.75  -5.86 -5.74 -12.05 -8.85 -19.54 -3.15 -7.60 -2.93 -18.99  -3.66 -26.78 -1.63 -17.56 4.62 -23.34 4.62 -24.78 0.00  -5.00 4.95 -17.01 6.62 -19.25 1.67 -2.25 2.62 -4.85 7.52  -11.86 1.12 -1.60 10.72 -10.05 15.24 -14.36 7.21 -6.87  29.22 -16.96 33.52 -17.02 6.79 -0.10 11.18 -3.15 21.49  -3.72 6.68 -0.37 22.30 4.02 29.61 5.51 13.30 2.71 12.02  5.79 23.95 12.28 11.94 6.48 16.91 11.76 19.38 18.46 z  ",
    stroke: "#DAAA00",
    strokeWidth: 1,
    fill: "#002855"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, -62) scale(15)"
  }, /*#__PURE__*/React.createElement("polygon", {
    stroke: "#DAAA00",
    strokeWidth: 0.05,
    fill: "white",
    points: "  0.00000 , -1.00000  0.29389 , -0.40451  0.95106 , -0.30902  0.47553 , 0.15451  0.58779 , 0.80902  0.00000 , 0.50000  -0.58779 , 0.80902  -0.47553 , 0.15451  -0.95106 , -0.30902  -0.29389 , -0.40451  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  0, 0  0.00000 , -1.00000  0.29389 , -0.40451  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  0, 0  0.95106 , -0.30902  0.71329 , -0.07725  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  0, 0  0.47553 , 0.15451  0.58779 , 0.80902  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  0, 0  0.00000 , 0.50000  -0.58779 , 0.80902  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  0, 0  -0.95106 , -0.30902  -0.29389 , -0.40451  "
  }))), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 81,
    fill: "#DAAA00",
    transform: "rotate(37.5)"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 81,
    fill: "#DAAA00",
    transform: "rotate(-37.5)"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 81,
    fill: "#DAAA00",
    transform: "rotate(82.5)"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 81,
    fill: "#DAAA00",
    transform: "rotate(-145)"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    r: 2.1,
    cy: 81,
    fill: "#DAAA00",
    transform: "rotate(-176.5)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-129.8) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -1.3 5.5  -1.8 5.8  -1.8 6  1.8 6  1.8 5.8  1.3 5.5  1.3 -3.4  5 -3.4  5.3 -2.9  5.5 -2.9  5.5 -6  -5.5 -6  -5.5 -2.9  -5.3 -2.9  -5 -3.4  -1.3 -3.4  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-119.3) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5.5 5.5  -6 5.8  -6 6  -2.4 6  -2.4 5.8  -2.9 5.5  -2.9 -5.5  -2.4 -5.8  -2.4 -6  -6 -6  -6 -5.8  -5.5 -5.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  5.5 5.5  6 5.8  6 6  2.4 6  2.4 5.8  2.9 5.5  2.9 -5.5  2.4 -5.8  2.4 -6  6 -6  6 -5.8  5.5 -5.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5 -1.3  -5 1.3  5 1.3  5 -1.3  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-108.2) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -4.5 5.5  -5 5.8  -5 6  4.5 6  4.5 2.9  4.3 2.9  4 3.4  -1.9 3.4  -1.9 1.3  2.5 1.3  2.5 -1.3  -1.9 -1.3  -1.9 -3.4  4 -3.4  4.3 -2.9  4.5 -2.9  4.5 -6  -5 -6  -5 -5.8  -4.5 -5.5  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-87.3) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "  M-4.2 -6  V0  C-4.2 6.3 4.2 6.3 4.2 0  V-6  ",
    stroke: "#DAAA00",
    strokeWidth: 2.6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5.5 -5.5  -6 -5.8  -6 -6  -2.4 -6  -2.4 -5.8  -2.9 -5.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  5.5 -5.5  6 -5.8  6 -6  2.4 -6  2.4 -5.8  2.9 -5.5  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-76.5) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5.5 5.5  -6 5.8  -6 6  -2.9 6  -2.9 -6  -6 -6  -6 -5.8  -5.5 -5.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  5.5 5.5  6 5.8  6 6  2.9 6  2.9 -6  6 -6  6 -5.8  5.5 -5.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5.5 -6  2.9 6  5.5 6  -2.9 -6  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-68.2) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -1.3 5.5  -1.8 5.8  -1.8 6  1.8 6  1.8 5.8  1.3 5.5  1.3 -5.5  1.8 -5.8  1.8 -6  -1.8 -6  -1.8 -5.8  -1.3 -5.5  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-60.6) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -7 -6  -1.3 6  1.3 6  7 -6  4.4 -6  -1.3 6  1.3 6  -4.4 -6  "
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-50) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -4.5 5.5  -5 5.8  -5 6  4.5 6  4.5 2.9  4.3 2.9  4 3.4  -1.9 3.4  -1.9 1.3  2.5 1.3  2.5 -1.3  -1.9 -1.3  -1.9 -3.4  4 -3.4  4.3 -2.9  4.5 -2.9  4.5 -6  -5 -6  -5 -5.8  -4.5 -5.5  "
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-40) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "  M-4.2 6  V-4.7  H0  C5.5 -4.7 5.5 0 0 0  H-4.2  M-0.5 0  L 3.7 4.7  ",
    stroke: "#DAAA00",
    strokeWidth: 2.6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.7,
    cy: 4.7,
    r: 1.3,
    fill: "#DAAA00"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5.5 5.5  -6 5.8  -6 6  -2.4 6  -2.4 5.8  -2.9 5.5  "
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-30.2) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "  M-3.7 3.3  C-3.7 3.3 -5 4.7 0 4.7  C5 4.7 5 0 0 0  C-5 0 -5 -4.7 0 -4.7  C5 -4.7 3.7 -3.3 3.7 -3.3  ",
    stroke: "#DAAA00",
    strokeWidth: 2.6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -3.7,
    cy: 3.3,
    r: 1.3,
    fill: "#DAAA00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.7,
    cy: -3.3,
    r: 1.3,
    fill: "#DAAA00"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-23) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -1.3 5.5  -1.8 5.8  -1.8 6  1.8 6  1.8 5.8  1.3 5.5  1.3 -5.5  1.8 -5.8  1.8 -6  -1.8 -6  -1.8 -5.8  -1.3 -5.5  "
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-15.7) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -1.3 5.5  -1.8 5.8  -1.8 6  1.8 6  1.8 5.8  1.3 5.5  1.3 -3.4  5 -3.4  5.3 -2.9  5.5 -2.9  5.5 -6  -5.5 -6  -5.5 -2.9  -5.3 -2.9  -5 -3.4  -1.3 -3.4  "
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-6) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -6 -6  -6 -5.8  -5 -5.2  -5.5 -6  -1.3 1.5  1.3 1.5  -2.9 -6  -2.9 -5.5  -2.4 -5.8  -2.4 -6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  6 -6  6 -5.8  5 -5.2  5.5 -6  1.3 1.5  -1.3 1.5  2.9 -6  2.9 -5.5  2.4 -5.8  2.4 -6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -1.3 1.4  -1.3 5.5  -1.8 5.8  -1.8 6  1.8 6  1.8 5.8  1.3 5.5  1.3 1.4  "
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(14.4) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4.7,
    stroke: "#DAAA00",
    strokeWidth: 2.6,
    fill: "none"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(25.2) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -4.5 5.5  -5 5.8  -5 6  -1.4 6  -1.4 5.8  -1.9 5.5  -1.9 1.8  3.5 1.8  3.5 -0.8  -1.9 -0.8  -1.9 -3.4  4 -3.4  4.3 -2.9  4.5 -2.9  4.5 -6  -5 -6  -5 -5.8  -4.5 -5.5  "
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45.4) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4.7,
    stroke: "#DAAA00",
    strokeWidth: 2.6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -2,
    width: 6.5,
    height: 4,
    fill: "#002855"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(55.7) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -6 6  -5.5 5.2  -6.5 5.8  -6.5 6  -2.9 6  -2.9 5.8  -3.9 5.2  -3.4 6  -2.5 2.7  0.1 2.7  0.1 0.1  -1.433 0.1  0.6 -6  -2.5 -6  -2.5 -5.8  -1.5 -5.2  -2 -6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  6 6  5.5 5.2  6.5 5.8  6.5 6  2.9 6  2.9 5.8  3.9 5.2  3.4 6  2.5 2.7  -0.1 2.7  -0.1 0.1  1.433 0.1  -0.6 -6  2.5 -6  2.5 -5.8  1.5 -5.2  2 -6  "
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(66.8) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5 5.5  -5.5 5.8  -5.5 6  5 6  5 2.9  4.8 2.9  4.5 3.4  -2.4 3.4  -2.4 -6  -5.5 -6  -5.5 -5.8  -5 -5.5  "
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(73.7) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -1.3 5.5  -1.8 5.8  -1.8 6  1.8 6  1.8 5.8  1.3 5.5  1.3 -5.5  1.8 -5.8  1.8 -6  -1.8 -6  -1.8 -5.8  -1.3 -5.5  "
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(81.5) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -4.5 5.5  -5 5.8  -5 6  -1.4 6  -1.4 5.8  -1.9 5.5  -1.9 1.8  3.5 1.8  3.5 -0.8  -1.9 -0.8  -1.9 -3.4  4 -3.4  4.3 -2.9  4.5 -2.9  4.5 -6  -5 -6  -5 -5.8  -4.5 -5.5  "
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(91.2) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4.7,
    stroke: "#DAAA00",
    strokeWidth: 2.6,
    fill: "none"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(102.8) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "  M-4.2 6  V-4.7  H0  C5.5 -4.7 5.5 0 0 0  H-4.2  M-0.5 0  L 3.7 4.7  ",
    stroke: "#DAAA00",
    strokeWidth: 2.6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.7,
    cy: 4.7,
    r: 1.3,
    fill: "#DAAA00"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5.5 5.5  -6 5.8  -6 6  -2.4 6  -2.4 5.8  -2.9 5.5  "
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(114.6) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5.5 5.5  -6 5.8  -6 6  -2.9 6  -2.9 -6  -6 -6  -6 -5.8  -5.5 -5.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  5.5 5.5  6 5.8  6 6  2.9 6  2.9 -6  6 -6  6 -5.8  5.5 -5.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5.5 -6  2.9 6  5.5 6  -2.9 -6  "
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(123) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -1.3 5.5  -1.8 5.8  -1.8 6  1.8 6  1.8 5.8  1.3 5.5  1.3 -5.5  1.8 -5.8  1.8 -6  -1.8 -6  -1.8 -5.8  -1.3 -5.5  "
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(131.2) translate(0, -81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -6 6  -5.5 5.2  -6.5 5.8  -6.5 6  -2.9 6  -2.9 5.8  -3.9 5.2  -3.4 6  -2.5 2.7  0.1 2.7  0.1 0.1  -1.433 0.1  0.6 -6  -2.5 -6  -2.5 -5.8  -1.5 -5.2  -2 -6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  6 6  5.5 5.2  6.5 5.8  6.5 6  2.9 6  2.9 5.8  3.9 5.2  3.4 6  2.5 2.7  -0.1 2.7  -0.1 0.1  1.433 0.1  -0.6 -6  2.5 -6  2.5 -5.8  1.5 -5.2  2 -6  "
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(15) translate(0, 81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "  M-4.2 -1  V-4.7  H0  C5.5 -4.7 5.5 4.7 0 4.7  H-4.2  V1  Z  ",
    stroke: "#DAAA00",
    strokeWidth: 2.6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5.5 5.5  -6 5.8  -6 6  -5 6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5.5 -5.5  -6 -5.8  -6 -6  -5 -6  "
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(7) translate(0, 81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -6 6  -5.5 5.2  -6.5 5.8  -6.5 6  -2.9 6  -2.9 5.8  -3.9 5.2  -3.4 6  -2.5 2.7  0.1 2.7  0.1 0.1  -1.433 0.1  0.6 -6  -2.5 -6  -2.5 -5.8  -1.5 -5.2  -2 -6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  6 6  5.5 5.2  6.5 5.8  6.5 6  2.9 6  2.9 5.8  3.9 5.2  3.4 6  2.5 2.7  -0.1 2.7  -0.1 0.1  1.433 0.1  -0.6 -6  2.5 -6  2.5 -5.8  1.5 -5.2  2 -6  "
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-1.5) translate(0, 81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -7 -6  -1.3 6  1.3 6  7 -6  4.4 -6  -1.3 6  1.3 6  -4.4 -6  "
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-9) translate(0, 81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -1.3 5.5  -1.8 5.8  -1.8 6  1.8 6  1.8 5.8  1.3 5.5  1.3 -5.5  1.8 -5.8  1.8 -6  -1.8 -6  -1.8 -5.8  -1.3 -5.5  "
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-15) translate(0, 81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "  M-3.7 3.3  C-3.7 3.3 -5 4.7 0 4.7  C5 4.7 5 0 0 0  C-5 0 -5 -4.7 0 -4.7  C5 -4.7 3.7 -3.3 3.7 -3.3  ",
    stroke: "#DAAA00",
    strokeWidth: 2.6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -3.7,
    cy: 3.3,
    r: 1.3,
    fill: "#DAAA00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.7,
    cy: -3.3,
    r: 1.3,
    fill: "#DAAA00"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36.5, 26) rotate(23) scale(0.55)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5 5.5  -5.5 5.8  -5.5 6  5 6  5 2.9  4.8 2.9  4.5 3.4  -2.4 3.4  -2.4 -6  -5.5 -6  -5.5 -5.8  -5 -5.5  "
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.5, 29.3) rotate(37) scale(0.55)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -4.5 5.5  -5 5.8  -5 6  4.5 6  4.5 2.9  4.3 2.9  4 3.4  -1.9 3.4  -1.9 1.3  2.5 1.3  2.5 -1.3  -1.9 -1.3  -1.9 -3.4  4 -3.4  4.3 -2.9  4.5 -2.9  4.5 -6  -5 -6  -5 -5.8  -4.5 -5.5  "
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26, 34) rotate(54) scale(0.55)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -1.3 5.5  -1.8 5.8  -1.8 6  1.8 6  1.8 5.8  1.3 5.5  1.3 -3.4  5 -3.4  5.3 -2.9  5.5 -2.9  5.5 -6  -5.5 -6  -5.5 -2.9  -5.3 -2.9  -5 -3.4  -1.3 -3.4  "
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20.5, 42.5) rotate(55) scale(0.55)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -1.3 5.5  -1.8 5.8  -1.8 6  1.8 6  1.8 5.8  1.3 5.5  1.3 -3.4  5 -3.4  5.3 -2.9  5.5 -2.9  5.5 -6  -5.5 -6  -5.5 -2.9  -5.3 -2.9  -5 -3.4  -1.3 -3.4  "
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.5, 48.2) rotate(50) scale(0.55)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5.5 5.5  -6 5.8  -6 6  -2.4 6  -2.4 5.8  -2.9 5.5  -2.9 -5.5  -2.4 -5.8  -2.4 -6  -6 -6  -6 -5.8  -5.5 -5.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  5.5 5.5  6 5.8  6 6  2.4 6  2.4 5.8  2.9 5.5  2.9 -5.5  2.4 -5.8  2.4 -6  6 -6  6 -5.8  5.5 -5.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5 -1.3  -5 1.3  5 1.3  5 -1.3  "
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.7, 53.3) rotate(32) scale(0.55)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -4.5 5.5  -5 5.8  -5 6  4.5 6  4.5 2.9  4.3 2.9  4 3.4  -1.9 3.4  -1.9 1.3  2.5 1.3  2.5 -1.3  -1.9 -1.3  -1.9 -3.4  4 -3.4  4.3 -2.9  4.5 -2.9  4.5 -6  -5 -6  -5 -5.8  -4.5 -5.5  "
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4, 56) rotate(15) scale(0.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "  M-4.2 6  V-4.7  H0  C5.5 -4.7 5.5 0 0 0  H-4.2  M-0.5 0  L 3.7 4.7  ",
    stroke: "#DAAA00",
    strokeWidth: 2.6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.7,
    cy: 4.7,
    r: 1.3,
    fill: "#DAAA00"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5.5 5.5  -6 5.8  -6 6  -2.4 6  -2.4 5.8  -2.9 5.5  "
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.5, 57) rotate(5) scale(0.55)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -4.5 5.5  -5 5.8  -5 6  4.5 6  4.5 2.9  4.3 2.9  4 3.4  -1.9 3.4  -1.9 1.3  2.5 1.3  2.5 -1.3  -1.9 -1.3  -1.9 -3.4  4 -3.4  4.3 -2.9  4.5 -2.9  4.5 -6  -5 -6  -5 -5.8  -4.5 -5.5  "
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.9, 55.5) rotate(-22) scale(0.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "  M-4.2 1.3  V-4.7  H0  C5.5 -4.7 5.5 0 0 0  H-4.2  M-4.2 -1.3  V4.7  H0  C5.5 4.7 5.5 0 0 0  H-4.2  ",
    stroke: "#DAAA00",
    strokeWidth: 2.6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5.5 5.5  -6 5.8  -6 6  -4.2 6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5.5 -5.5  -6 -5.8  -6 -6  -4.2 -6  "
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18, 52.3) rotate(-32) scale(0.55)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -4.5 5.5  -5 5.8  -5 6  4.5 6  4.5 2.9  4.3 2.9  4 3.4  -1.9 3.4  -1.9 1.3  2.5 1.3  2.5 -1.3  -1.9 -1.3  -1.9 -3.4  4 -3.4  4.3 -2.9  4.5 -2.9  4.5 -6  -5 -6  -5 -5.8  -4.5 -5.5  "
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25, 30) rotate(8) scale(0.55)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5 5.5  -5.5 5.8  -5.5 6  5 6  5 2.9  4.8 2.9  4.5 3.4  -2.4 3.4  -2.4 -6  -5.5 -6  -5.5 -5.8  -5 -5.5  "
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 30.7) rotate(10) scale(0.55)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -1.3 5.5  -1.8 5.8  -1.8 6  1.8 6  1.8 5.8  1.3 5.5  1.3 -5.5  1.8 -5.8  1.8 -6  -1.8 -6  -1.8 -5.8  -1.3 -5.5  "
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.4, 32.3) rotate(8) scale(0.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "  M4 -3.5  C-3 -9   -7 4.7   0 4.7  L3.5 4.7  L3.5 0  ",
    stroke: "#DAAA00",
    strokeWidth: 2.6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  2.2 0.5  1.7 0.2  1.7 0  5.3 0  5.3 0.2  4.8 0.5  "
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.3, 33) rotate(0) scale(0.55)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5.5 5.5  -6 5.8  -6 6  -2.4 6  -2.4 5.8  -2.9 5.5  -2.9 -5.5  -2.4 -5.8  -2.4 -6  -6 -6  -6 -5.8  -5.5 -5.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  5.5 5.5  6 5.8  6 6  2.4 6  2.4 5.8  2.9 5.5  2.9 -5.5  2.4 -5.8  2.4 -6  6 -6  6 -5.8  5.5 -5.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -5 -1.3  -5 1.3  5 1.3  5 -1.3  "
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.5, 32.5) rotate(-5) scale(0.55)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DAAA00",
    points: "  -1.3 5.5  -1.8 5.8  -1.8 6  1.8 6  1.8 5.8  1.3 5.5  1.3 -3.4  5 -3.4  5.3 -2.9  5.5 -2.9  5.5 -6  -5.5 -6  -5.5 -2.9  -5.3 -2.9  -5 -3.4  -1.3 -3.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUcdavis);
export default __webpack_public_path__ + "static/media/ucdavis.0fa63af004bda8ee931a9ca49ab3fc6e.svg";
export { ForwardRef as ReactComponent };